export default "__VITE_ASSET__Bx7IrAo0__"